import { Serializable } from "../core";

export class Color implements Serializable<Color> {
  id!: number;
  title!: string;
  color!: string;

  deserialize(json: any): Color {
    this.id = json.id;
    this.color = json.color;
    this.title = json.title;
    return this;
  }
}
